import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Helpers } from "../../helpers/Helpers";
import { storeActivityIndicator } from "../../redux/reducers/authSlice";
import toast from "react-hot-toast";
import GoogleMap from "google-map-react";
import { GOOGLE_HARITA_ANAHTARI } from "../../helpers/haritaAnahtari";
import { MarkerWithLabel } from "@googlemaps/markerwithlabel";
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import moment from "moment";
import { DeviceDataService } from "../../services/DeviceDataService";
import { GetDeviceDataListForMapResponse, GetDeviceDataListForMapResponseItem } from "../../models/response/deviceData/GetDeviceDataListForMapResponse";
import { GetAreaListResponse, GetAreaListResponseItem } from "../../models/response/area/GetAreaListResponse";
import { AreaService } from "../../services/AreaService";
import { GetLastEventsResponse, GetLastEventsResponseItem } from "../../models/response/event/GetLastEventsResponse";
import { EventService } from "../../services/EventService";
import { GetDeviceHistoryBetweenTwoDatesResponse, GetDeviceHistoryBetweenTwoDatesResponseItem } from "../../models/response/deviceDataHistory/GetDeviceHistoryBetweenTwoDatesResponse";
import { GetAreaByIdResponseData } from "../../models/response/area/GetAreaByIdResponse";
import { GetAreaTypeListResponse, GetAreaTypeListResponseItem } from "../../models/response/areaType/GetAreaTypeListResponse";
import { DeviceDataHistoryService } from "../../services/DeviceDataHistoryService";
import { AreaTypeService } from "../../services/AreaTypeService";
import { ConstantService } from "../../services/ConstantService";
import { GetConstantListResponse, GetConstantListResponseItem } from "../../models/response/constant/GetConstantListResponse";
import './Components/MapScreen.css'
import AreaDetail from "./Components/AreaDetail";
import CreateAreaModal from "./Components/CreateAreaModal";
import VehicleDetail from "./Components/VehicleDetail";
import VehicleDetailHistory from "./Components/VehicleDetailHistory";
import { rotaCiz, sinyalDalgasiHtml } from "./Components/RotaAnimasyonu";

export interface GeneralStateModel {
    ____tMarkers: any,
    ____tMap: any,
    ____tMaps: any,
    ____tMarkerClusterer: any,
    ____tPolylines: any,
    ____tDrawingPolygonPoints: any,
    ____tDrawingPolygon: any,
    ____tOnMapClick: any,
    ____tOnMapRightClick: any
    ____tAreas: any
    ____tInfoWindow: google.maps.InfoWindow | undefined
}

export interface FocusObj {
    deviceId: string | null | undefined
    type: 'OPEN' | 'CLOSE'
}

export interface VehicleDetailHistoryModel {
    startDate: Date
    endDate: Date
}

const Map = () => {
    const dispatch = useDispatch();
    // const [____markers, setMarkers] = useState<any[]>([])
    // const [___amap, setMap] = useState<any>(undefined)
    // const [___amaps, setMaps] = useState(undefined);
    // const [___amarkerClusterer, setMarkerClusterer] = useState<MarkerClusterer | undefined>(undefined);
    // const [___apolyline, setPolyline] = useState<any>(undefined);
    const [focusedDeviceId, setFocusedDeviceId] = useState<string | null | undefined>(undefined);
    const [data, setData] = useState<GetDeviceDataListForMapResponseItem[]>([])
    const [vehicleDetailHistory, setVehicleDetailHistory] = useState<VehicleDetailHistoryModel | undefined>(undefined);
    const [historyData, setHistoryData] = useState<GetDeviceHistoryBetweenTwoDatesResponseItem[]>([]);
    const [historyIndex, setHistoryIndex] = useState(0);
    const [searchedPlate, setSearchedPlate] = useState('');
    const [isPolygonDrawing, setIsPolygonDrawing] = useState(false);
    const [areaList, setAreaList] = useState<GetAreaListResponseItem[]>([]);
    const [isAreaDetailShown, setIsAreaDetailShown] = useState(false);
    const [isDebug, setIsDebug] = useState(false);
    const [hiddenAreas, setHiddenAreas] = useState<string[]>([]);
    const [toBeUpdatedArea, setToBeUpdatedArea] = useState<GetAreaByIdResponseData | undefined>(undefined);
    const [withKml, setWithKml] = useState(false);
    const [createAreaModalVisible, setCreateAreaModalVisible] = useState(false);
    const [lastEvents, setLastEvents] = useState<GetLastEventsResponseItem[]>([]);
    const [activeDetailTab, setActiveDetailTab] = useState(1);
    const [lastEventsTake, setLastEventsTake] = useState(10);

    const [generalState, setGeneralState] = useState<GeneralStateModel>({
        ____tMarkers: undefined,
        ____tMap: undefined,
        ____tMaps: undefined,
        ____tMarkerClusterer: undefined,
        ____tPolylines: undefined,
        ____tDrawingPolygonPoints: [],
        ____tDrawingPolygon: undefined,
        ____tOnMapClick: undefined,
        ____tOnMapRightClick: undefined,
        ____tAreas: [],
        ____tInfoWindow: undefined
    })

    const searchPlate = (e: any) => {
        e.preventDefault();

        if (Helpers.isEmpty(searchedPlate))
            return;

        var foundDevice = data.find(x => x.plate.toLowerCase().replaceAll(' ', '').includes(searchedPlate.toLowerCase().replaceAll(' ', '')));

        if (foundDevice) {
            setSearchedPlate('');
            focusToMarker(foundDevice.deviceId);
        }
        else {
            toast.error('Araç bulunamadı.')
        }
    }

    const refreshTime = 15000;

    const defaultProps = {
        center: {
            lat: 39.1268133305493,
            lng: 35.405874386437986
        },
        zoom: 6
    };

    useEffect(() => {
        const interval = setInterval(() => {
            getData(false, undefined)
        }, refreshTime);
        return () => clearInterval(interval);
    }, []);

    const getData = async (_isOneTime: boolean, _focusObj: FocusObj | undefined) => {
        try {
            if (_isOneTime)
                dispatch(storeActivityIndicator(true))

            var response: GetDeviceDataListForMapResponse = await DeviceDataService.getDeviceDataListForMap();

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data);

            var response2: GetAreaListResponse = await AreaService.getAreaList();

            if (!response2.isSuccess) {
                toast.error(response2.message)
                return;
            }

            setAreaList(response2.data);

            setCreateAreaModalVisible((_createAreaModalVisible) => {
                setIsPolygonDrawing((_isPolygonDrawing) => {
                    setHistoryData((_historyData) => {
                        setFocusedDeviceId((_focusedDeviceId) => {
                            if (_focusObj) {
                                if (_focusObj.type == "OPEN")
                                    _focusedDeviceId = _focusObj.deviceId;
                                else
                                    _focusedDeviceId = undefined;
                            }

                            setGeneralState((_generalState) => {
                                if (!Helpers.isEmpty(_focusedDeviceId)) {
                                    response.data = response.data.filter(x => x.deviceId == _focusedDeviceId);
                                }

                                // geçmiş var ise hiçbirşey yapma
                                if (_historyData && _historyData.length > 0)
                                    return _generalState;

                                // çizim yapılıyor ise hiçbirşey yapma
                                if (_isPolygonDrawing || _createAreaModalVisible)
                                    return _generalState;

                                // çizilme eventini ve çizilenleri kaldır.    
                                if (_generalState.____tOnMapClick) {
                                    google.maps.event.removeListener(_generalState.____tOnMapClick);
                                    _generalState.____tOnMapClick = undefined;
                                }

                                if (_generalState.____tOnMapRightClick) {
                                    google.maps.event.removeListener(_generalState.____tOnMapRightClick);
                                    _generalState.____tOnMapRightClick = undefined;
                                }

                                if (_generalState.____tDrawingPolygon) {
                                    _generalState.____tDrawingPolygon.setMap(null);
                                    _generalState.____tDrawingPolygon = undefined;
                                }

                                _generalState.____tDrawingPolygonPoints = [];

                                var _hiddenAreasStr = localStorage.getItem('HiddenAreas');
                                var _hiddenAreas: string[] = _hiddenAreasStr ? JSON.parse(_hiddenAreasStr) : []

                                _generalState.____tAreas.forEach((item: any) => {
                                    item.setMap(null)
                                })

                                var areas = response2.data.filter(x => !_hiddenAreas.includes(x.areaId)).map((item) => {
                                    var p = new google.maps.Polygon({
                                        paths: item.latLngList.map(x => new google.maps.LatLng(x.lat, x.lng)),
                                        strokeWeight: 0,
                                        fillColor: item.color,
                                        fillOpacity: item.isTransparent ? 0 : 0.5,
                                        map: _generalState.____tMap
                                    });

                                    p.addListener('click', (event: any) => {
                                        setIsPolygonDrawing((_isPolygonDrawing) => {
                                            setGeneralState((_generalState) => {
                                                if (_isPolygonDrawing) {
                                                    setPolygonPoint(undefined, event.latLng.lat(), event.latLng.lng())
                                                }

                                                return _generalState;
                                            })

                                            return _isPolygonDrawing;
                                        })
                                    })

                                    p.addListener('rightclick', (event: any) => {
                                        setIsPolygonDrawing((_isPolygonDrawing) => {
                                            if (_isPolygonDrawing) {
                                                removeLastPolygonPoint();
                                            }
                                            return _isPolygonDrawing;
                                        })
                                    })

                                    return p;
                                });

                                response2.data.filter(x => !_hiddenAreas.includes(x.areaId)).map((item) => {
                                    for (var i = 0; i < item.latLngList.length; i++) {
                                        if (i == 0)
                                            continue;

                                        var latlng1 = new google.maps.LatLng(item.latLngList[i - 1].lat, item.latLngList[i - 1].lng);
                                        var latlng2 = new google.maps.LatLng(item.latLngList[i].lat, item.latLngList[i].lng);

                                        var p = new google.maps.Polygon({
                                            paths: [latlng1, latlng2],
                                            strokeColor: item.borderColor,
                                            strokeOpacity: 1,
                                            strokeWeight: item.borderWidth,
                                            fillOpacity: 0,
                                            map: _generalState.____tMap
                                        });

                                        google.maps.event.addListener(p, "mouseover", function (event: any) {
                                            setIsPolygonDrawing((_isPolygonDrawing) => {
                                                setGeneralState((_generalState) => {
                                                    if (_generalState.____tInfoWindow) {
                                                        google.maps.event.clearInstanceListeners(_generalState.____tInfoWindow);
                                                        _generalState.____tInfoWindow.close();
                                                        _generalState.____tInfoWindow = undefined;
                                                    }

                                                    if (_generalState.____tMap.getZoom() > 9 && !_isPolygonDrawing) {
                                                        _generalState.____tInfoWindow = new google.maps.InfoWindow();
                                                        _generalState.____tInfoWindow.setContent(item.areaName + " - " + item.areaTypeName);
                                                        _generalState.____tInfoWindow.setPosition(event.latLng);
                                                        _generalState.____tInfoWindow.setOptions({
                                                            pixelOffset: new google.maps.Size(0, 0)
                                                        })
                                                        _generalState.____tInfoWindow.open(_generalState.____tMap);
                                                    }


                                                    return _generalState;
                                                })

                                                return _isPolygonDrawing;
                                            })
                                        });

                                        google.maps.event.addListener(p, 'mouseout', function () {
                                            setGeneralState((_generalState) => {
                                                if (_generalState.____tInfoWindow) {
                                                    google.maps.event.clearInstanceListeners(_generalState.____tInfoWindow);
                                                    _generalState.____tInfoWindow.close();
                                                    _generalState.____tInfoWindow = undefined;
                                                }

                                                return _generalState;
                                            })
                                        });

                                        areas.push(p);
                                    }

                                    var latlng1 = new google.maps.LatLng(item.latLngList[0].lat, item.latLngList[0].lng);
                                    var latlng2 = new google.maps.LatLng(item.latLngList[item.latLngList.length - 1].lat, item.latLngList[item.latLngList.length - 1].lng);

                                    var p = new google.maps.Polygon({
                                        paths: [latlng1, latlng2],
                                        strokeColor: item.borderColor,
                                        strokeOpacity: 1,
                                        strokeWeight: item.borderWidth,
                                        fillOpacity: 0,
                                        map: _generalState.____tMap
                                    });

                                    google.maps.event.addListener(p, "mouseover", function (event: any) {
                                        setIsPolygonDrawing((_isPolygonDrawing) => {
                                            setGeneralState((_generalState) => {
                                                if (_generalState.____tInfoWindow) {
                                                    google.maps.event.clearInstanceListeners(_generalState.____tInfoWindow);
                                                    _generalState.____tInfoWindow.close();
                                                    _generalState.____tInfoWindow = undefined;
                                                }

                                                if (_generalState.____tMap.getZoom() > 9 && !_isPolygonDrawing) {
                                                    _generalState.____tInfoWindow = new google.maps.InfoWindow();
                                                    _generalState.____tInfoWindow.setContent(item.areaName + " - " + item.areaTypeName);
                                                    _generalState.____tInfoWindow.setPosition(event.latLng);
                                                    _generalState.____tInfoWindow.setOptions({
                                                        pixelOffset: new google.maps.Size(0, 0)
                                                    })
                                                    _generalState.____tInfoWindow.open(_generalState.____tMap);
                                                }


                                                return _generalState;
                                            })

                                            return _isPolygonDrawing;
                                        })
                                    });

                                    google.maps.event.addListener(p, 'mouseout', function () {
                                        setGeneralState((_generalState) => {
                                            if (_generalState.____tInfoWindow) {
                                                google.maps.event.clearInstanceListeners(_generalState.____tInfoWindow);
                                                _generalState.____tInfoWindow.close();
                                                _generalState.____tInfoWindow = undefined;
                                            }

                                            return _generalState;
                                        })
                                    });

                                    areas.push(p);
                                })

                                _generalState.____tAreas = areas;

                                _generalState.____tMarkers.forEach((item: any) => {
                                    item.setMap(null)
                                })

                                _generalState.____tMarkers = [];

                                if (_generalState.____tPolylines) {

                                    _generalState.____tPolylines.forEach((item: any) => {
                                        item.setMap(null);
                                    });

                                    _generalState.____tPolylines = undefined;
                                }

                                _generalState.____tMarkerClusterer?.clearMarkers();

                                _generalState.____tMarkerClusterer?.setMap(null);

                                response.data.forEach((item) => {
                                    var _m = new MarkerWithLabel({
                                        icon: {
                                            url: Helpers.getEndpoint() + (`/markers/arrow-${item.statusColor}-${item.directionDegree}.png`),
                                            scaledSize: new google.maps.Size(20, 20),
                                            anchor: new google.maps.Point(10, 10),
                                        },
                                        position: new google.maps.LatLng(item.latitude, item.longitude),
                                        labelContent: `
                                            <div class="custom-map-marker">
                                                <div class="custom-map-car">
                                                    <img style="width: 100%; height: 100%;" src="${item.vehicleTypeImage}" />
                                                </div>
                                                <div class="custom-map-label">
                                                    ${item.plate}
                                                </div>
                                                ${sinyalDalgasiHtml(item.statusColor)}
                                            </div>
                                        `,
                                        labelAnchor: new google.maps.Point(-40, -95),
                                        title: item.deviceId
                                    })

                                    _generalState.____tMaps.event.addListener(_m, "click", function (e: any) {
                                        focusToMarker(_m.getTitle())
                                    });

                                    _generalState.____tMarkers.push(_m);
                                })

                                _generalState.____tMarkerClusterer = new MarkerClusterer({
                                    markers: _generalState.____tMarkers,
                                    map: _generalState.____tMap,
                                    algorithmOptions: {
                                        maxZoom: 12
                                    }
                                })

                                if (_focusedDeviceId) {
                                    var obj = response.data.find(x => x.deviceId == _focusedDeviceId);

                                    if (obj) {
                                        _generalState.____tMap.panTo(new google.maps.LatLng(obj.latitude, obj.longitude));
                                        _generalState.____tMap.setZoom(17, true);
                                    }
                                }

                                // if (!_isOneTime)
                                //     _generalState.____tTimeout = setTimeout(() => {
                                //         getData(false)
                                //     }, refreshTime);

                                return _generalState;
                            })

                            return _focusedDeviceId;
                        })

                        return _historyData;
                    })

                    return _isPolygonDrawing;
                })

                return _createAreaModalVisible;
            })
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const getLastEvents = async (_take: number) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: GetLastEventsResponse = await EventService.getLastEvents(focusedDeviceId, _take);

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setLastEvents(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const focusToMarker = async (_focusedDeviceId: string | null | undefined, _activeDetailTab?: number) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: GetLastEventsResponse = await EventService.getLastEvents(_focusedDeviceId, lastEventsTake);

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setActiveDetailTab(_activeDetailTab ?? 1);

            setLastEvents(response.data);

            getData(true, { deviceId: _focusedDeviceId, type: 'OPEN' });

        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const handleApiLoaded = async (map: any, maps: any) => {
        try {
            dispatch(storeActivityIndicator(true));

            var response: GetDeviceDataListForMapResponse = await DeviceDataService.getDeviceDataListForMap();

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data)

            var response2: GetAreaListResponse = await AreaService.getAreaList();

            if (!response2.isSuccess) {
                toast.error(response2.message)
                return;
            }

            setAreaList(response2.data)

            var _hiddenAreasStr = localStorage.getItem('HiddenAreas');
            var _hiddenAreas: string[] = _hiddenAreasStr ? JSON.parse(_hiddenAreasStr) : []

            setHiddenAreas(_hiddenAreas);

            var areas = response2.data.filter(x => !_hiddenAreas.includes(x.areaId)).map((item) => {
                var p = new google.maps.Polygon({
                    paths: item.latLngList.map(x => new google.maps.LatLng(x.lat, x.lng)),
                    strokeWeight: 0,
                    fillColor: item.color,
                    fillOpacity: item.isTransparent ? 0 : 0.5,
                    map: map
                });

                p.addListener('click', (event: any) => {
                    setIsPolygonDrawing((_isPolygonDrawing) => {
                        setGeneralState((_generalState) => {
                            if (_isPolygonDrawing) {
                                setPolygonPoint(undefined, event.latLng.lat(), event.latLng.lng())
                            }
                            // else {
                            //     if (_generalState.____tInfoWindow) {
                            //         google.maps.event.clearInstanceListeners(_generalState.____tInfoWindow);
                            //         _generalState.____tInfoWindow.close();
                            //     }

                            //     _generalState.____tInfoWindow = new google.maps.InfoWindow();
                            //     _generalState.____tInfoWindow.setContent(item.areaName + "<br/>" + item.areaTypeName);
                            //     _generalState.____tInfoWindow.setPosition(event.latLng);
                            //     _generalState.____tInfoWindow.open(_generalState.____tMap);
                            // }

                            return _generalState;
                        })

                        return _isPolygonDrawing;
                    })
                })

                p.addListener('rightclick', (event: any) => {
                    setIsPolygonDrawing((_isPolygonDrawing) => {
                        if (_isPolygonDrawing) {
                            removeLastPolygonPoint();
                        }
                        return _isPolygonDrawing;
                    })
                })

                return p;
            });

            response2.data.filter(x => !_hiddenAreas.includes(x.areaId)).map((item) => {
                for (var i = 0; i < item.latLngList.length; i++) {
                    if (i == 0)
                        continue;

                    var latlng1 = new google.maps.LatLng(item.latLngList[i - 1].lat, item.latLngList[i - 1].lng);
                    var latlng2 = new google.maps.LatLng(item.latLngList[i].lat, item.latLngList[i].lng);

                    var p = new google.maps.Polygon({
                        paths: [latlng1, latlng2],
                        strokeColor: item.borderColor,
                        strokeOpacity: 1,
                        strokeWeight: item.borderWidth,
                        fillOpacity: 0,
                        map: map
                    });

                    google.maps.event.addListener(p, "mouseover", function (event: any) {
                        setIsPolygonDrawing((_isPolygonDrawing) => {
                            setGeneralState((_generalState) => {
                                if (_generalState.____tInfoWindow) {
                                    google.maps.event.clearInstanceListeners(_generalState.____tInfoWindow);
                                    _generalState.____tInfoWindow.close();
                                    _generalState.____tInfoWindow = undefined;
                                }

                                if (_generalState.____tMap.getZoom() > 9 && !_isPolygonDrawing) {
                                    _generalState.____tInfoWindow = new google.maps.InfoWindow();
                                    _generalState.____tInfoWindow.setContent(item.areaName + " - " + item.areaTypeName);
                                    _generalState.____tInfoWindow.setPosition(event.latLng);
                                    _generalState.____tInfoWindow.setOptions({
                                        pixelOffset: new google.maps.Size(0, 0)
                                    })
                                    _generalState.____tInfoWindow.open(_generalState.____tMap);
                                }


                                return _generalState;
                            })

                            return _isPolygonDrawing;
                        })
                    });

                    google.maps.event.addListener(p, 'mouseout', function () {
                        setGeneralState((_generalState) => {
                            if (_generalState.____tInfoWindow) {
                                google.maps.event.clearInstanceListeners(_generalState.____tInfoWindow);
                                _generalState.____tInfoWindow.close();
                                _generalState.____tInfoWindow = undefined;
                            }

                            return _generalState;
                        })
                    });

                    areas.push(p);
                }

                var latlng1 = new google.maps.LatLng(item.latLngList[0].lat, item.latLngList[0].lng);
                var latlng2 = new google.maps.LatLng(item.latLngList[item.latLngList.length - 1].lat, item.latLngList[item.latLngList.length - 1].lng);

                var p = new google.maps.Polygon({
                    paths: [latlng1, latlng2],
                    strokeColor: item.borderColor,
                    strokeOpacity: 1,
                    strokeWeight: item.borderWidth,
                    fillOpacity: 0,
                    map: map
                });

                google.maps.event.addListener(p, "mouseover", function (event: any) {
                    setIsPolygonDrawing((_isPolygonDrawing) => {
                        setGeneralState((_generalState) => {
                            if (_generalState.____tInfoWindow) {
                                google.maps.event.clearInstanceListeners(_generalState.____tInfoWindow);
                                _generalState.____tInfoWindow.close();
                                _generalState.____tInfoWindow = undefined;
                            }

                            if (_generalState.____tMap.getZoom() > 9 && !_isPolygonDrawing) {
                                _generalState.____tInfoWindow = new google.maps.InfoWindow();
                                _generalState.____tInfoWindow.setContent(item.areaName + " - " + item.areaTypeName);
                                _generalState.____tInfoWindow.setPosition(event.latLng);
                                _generalState.____tInfoWindow.setOptions({
                                    pixelOffset: new google.maps.Size(0, 0)
                                })
                                _generalState.____tInfoWindow.open(_generalState.____tMap);
                            }


                            return _generalState;
                        })

                        return _isPolygonDrawing;
                    })
                });

                google.maps.event.addListener(p, 'mouseout', function () {
                    setGeneralState((_generalState) => {
                        if (_generalState.____tInfoWindow) {
                            google.maps.event.clearInstanceListeners(_generalState.____tInfoWindow);
                            _generalState.____tInfoWindow.close();
                            _generalState.____tInfoWindow = undefined;
                        }

                        return _generalState;
                    })
                });

                areas.push(p);
            })

            var firstMarkers = response.data.map(function (x) {
                var _m = new MarkerWithLabel({
                    icon: {
                        url: Helpers.getEndpoint() + (`/markers/arrow-${x.statusColor}-${x.directionDegree}.png`),
                        scaledSize: new google.maps.Size(20, 20),
                        anchor: new google.maps.Point(10, 10),
                    },
                    position: new google.maps.LatLng(x.latitude, x.longitude),
                    labelContent: `
                        <div class="custom-map-marker">
                            <div class="custom-map-car">
                                <img style="width: 100%; height: 100%;" src="${x.vehicleTypeImage}" />
                            </div>
                            <div class="custom-map-label">
                                ${x.plate}
                            </div>
                            ${sinyalDalgasiHtml(x.statusColor)}
                        </div>
                    `,
                    labelAnchor: new google.maps.Point(-40, -95),
                    title: x.deviceId
                })

                maps.event.addListener(_m, "click", function (e: any) {
                    focusToMarker(_m.getTitle())
                });

                return _m;
            })

            setGeneralState({
                ...generalState,
                ____tMap: map,
                ____tMaps: maps,
                ____tMarkers: firstMarkers,
                ____tAreas: areas,
                ____tMarkerClusterer: new MarkerClusterer({
                    markers: firstMarkers,
                    map: map,
                    algorithmOptions: {
                        maxZoom: 12
                    }
                })
            })

            var focusedVehicleId = localStorage.getItem("FocusedVehicleId");

            if (focusedVehicleId) {
                var device = response.data.find(x => x.vehicleId == focusedVehicleId);

                if (device) {
                    var _activeDetailTab: number | undefined = undefined;

                    var focusedAmbarId = localStorage.getItem("FocusedAmbarId");

                    if (focusedAmbarId) {
                        for (var i = 0; i < device.ambars.length; i++) {
                            if (device.ambars[i].ambarId == focusedAmbarId) {
                                _activeDetailTab = (3 + (i + 1));
                            }
                        }

                        localStorage.removeItem("FocusedAmbarId");
                    }

                    focusToMarker(device.deviceId, _activeDetailTab);
                }

                localStorage.removeItem("FocusedVehicleId");
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    };

    const resetMap = () => {
        setGeneralState((_generalState) => {
            _generalState.____tMap.panTo(new google.maps.LatLng(defaultProps.center.lat, defaultProps.center.lng));
            _generalState.____tMap.setZoom(defaultProps.zoom, true);

            return _generalState;
        })
    }

    const resetFocusedDevice = () => {
        setVehicleDetailHistory(undefined);
        getData(true, { deviceId: undefined, type: 'CLOSE' });
    }

    const getDeviceHistory = async () => {
        try {
            if (Helpers.isEmpty(vehicleDetailHistory?.startDate) || Helpers.isEmpty(vehicleDetailHistory?.endDate)) {
                toast.error('Lütfen boş alan bırakmayınız!')
                return;
            }

            dispatch(storeActivityIndicator(true))

            var response: GetDeviceHistoryBetweenTwoDatesResponse = await DeviceDataHistoryService.getDeviceHistoryBetweenTwoDates(focusedDeviceId, moment(vehicleDetailHistory?.startDate).format("YYYY-MM-DD HH:mm:ss"), moment(vehicleDetailHistory?.endDate).format("YYYY-MM-DD HH:mm:ss"));

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            if (response.data.length == 0) {
                toast.error('Kayıt bulunamadı.')
                return;
            }

            setHistoryData(response.data)
            setHistoryIndex(0)
            prepareMapForHistory(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const stopDrawing = (_isCancel: boolean) => {
        //     generalState.____tDrawingPolygonPoints
        //
        // toast.error("Veritabanına kaydedilecek.")

        setIsPolygonDrawing(false);

        if (_isCancel || generalState.____tDrawingPolygonPoints.length == 0)
            getData(true, undefined);
        else
            setCreateAreaModalVisible(true);
        // getData();
    }

    const removeLastPolygonPoint = () => {
        setGeneralState((_generalState) => {
            if (_generalState.____tDrawingPolygonPoints.length <= 1) {
                return _generalState;
            }

            _generalState.____tDrawingPolygonPoints.pop();

            _generalState.____tDrawingPolygon.setMap(null);

            var p = new google.maps.Polygon({
                paths: _generalState.____tDrawingPolygonPoints.map(function (x: any) {
                    return new google.maps.LatLng(x.lat, x.lng)
                }),
                strokeColor: "#FF0000",
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: "#FF0000",
                fillOpacity: 0,
                map: _generalState.____tMap,
                zIndex: 999
            });

            p.addListener('click', (event: any) => {
                setIsPolygonDrawing((_isPolygonDrawing) => {
                    if (_isPolygonDrawing) {
                        setPolygonPoint(undefined, event.latLng.lat(), event.latLng.lng())
                    }

                    return _isPolygonDrawing;
                })
            })

            p.addListener('rightclick', (event: any) => {
                setIsPolygonDrawing((_isPolygonDrawing) => {
                    if (_isPolygonDrawing) {
                        removeLastPolygonPoint();
                    }

                    return _isPolygonDrawing;
                })
            })

            _generalState.____tDrawingPolygon = p;

            return _generalState;
        })
    }

    const setPolygonPoint = (mapsMouseEvent: any, _lat: number | undefined, _lng: number | undefined) => {
        setGeneralState((_generalState) => {
            var _json = _lat || _lng ? undefined : mapsMouseEvent.latLng.toJSON();
            _lat = _lat ? _lat : parseFloat(_json.lat.toFixed(6).replace(',', '.'));
            _lng = _lng ? _lng : parseFloat(_json.lng.toFixed(6).replace(',', '.'));

            _generalState.____tDrawingPolygonPoints.push({ lat: _lat, lng: _lng });

            if (!_generalState.____tDrawingPolygon) {
                var p = new google.maps.Polygon({
                    paths: [new google.maps.LatLng(_lat, _lng)],
                    strokeColor: "#FF0000",
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: "#FF0000",
                    fillOpacity: 0,
                    map: _generalState.____tMap,
                    zIndex: 999
                });

                p.addListener('click', (event: any) => {
                    setIsPolygonDrawing((_isPolygonDrawing) => {
                        if (_isPolygonDrawing) {
                            setPolygonPoint(undefined, event.latLng.lat(), event.latLng.lng())
                        }

                        return _isPolygonDrawing;
                    })
                })

                p.addListener('rightclick', (event: any) => {
                    setIsPolygonDrawing((_isPolygonDrawing) => {
                        if (_isPolygonDrawing) {
                            removeLastPolygonPoint();
                        }

                        return _isPolygonDrawing;
                    })
                })

                _generalState.____tDrawingPolygon = p;
            }
            else {
                _generalState.____tDrawingPolygon.setMap(null);

                var p = new google.maps.Polygon({
                    paths: _generalState.____tDrawingPolygonPoints.map(function (x: any) {
                        return new google.maps.LatLng(x.lat, x.lng)
                    }),
                    strokeColor: "#FF0000",
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: "#FF0000",
                    fillOpacity: 0,
                    map: _generalState.____tMap,
                    zIndex: 999
                });

                p.addListener('click', (event: any) => {
                    setIsPolygonDrawing((_isPolygonDrawing) => {
                        if (_isPolygonDrawing) {
                            setPolygonPoint(undefined, event.latLng.lat(), event.latLng.lng())
                        }

                        return _isPolygonDrawing;
                    })
                })

                p.addListener('rightclick', (event: any) => {
                    setIsPolygonDrawing((_isPolygonDrawing) => {
                        if (_isPolygonDrawing) {
                            removeLastPolygonPoint();
                        }

                        return _isPolygonDrawing;
                    })
                })

                _generalState.____tDrawingPolygon = p;
            }

            return _generalState;
        })
    };

    const startDrawing = () => {
        // clearInterval(generalState.____tTimeout);

        setIsPolygonDrawing(true);

        setGeneralState({
            ...generalState,
            // ____tTimeout: undefined,
            ____tOnMapClick: generalState.____tMap.addListener("click", function (mapsMouseEvent: any) {
                setPolygonPoint(mapsMouseEvent, undefined, undefined)
            }),
            ____tOnMapRightClick: generalState.____tMap.addListener("rightclick", function (mapsMouseEvent: any) {
                removeLastPolygonPoint()
            })
        })
    }

    const prepareMapForHistory = (items: GetDeviceHistoryBetweenTwoDatesResponseItem[]) => {
        setGeneralState((_generalState) => {
            _generalState.____tMarkers.forEach((item: any) => {
                item.setMap(null)
            })

            _generalState.____tMarkers = [];

            _generalState.____tMarkerClusterer?.clearMarkers();

            _generalState.____tMarkerClusterer?.setMap(null);

            _generalState.____tMarkerClusterer = undefined;

            var _m = new google.maps.Marker({
                map: _generalState.____tMap,
                icon: {
                    url: Helpers.getEndpoint() + (`/markers/arrow-${items[0].statusColor}-${items[0].directionDegree}.png`),
                    scaledSize: new google.maps.Size(20, 20),
                    anchor: new google.maps.Point(10, 10),
                },
                position: new google.maps.LatLng(items[0].latitude, items[0].longitude),
            });

            _generalState.____tMarkers.push(_m);

            _generalState.____tMap.panTo(new google.maps.LatLng(items[0].latitude, items[0].longitude))
            _generalState.____tMap.setZoom(17, true);

            if (_generalState.____tPolylines) {

                _generalState.____tPolylines.forEach((item: any) => {
                    item.setMap(null);
                });

                _generalState.____tPolylines = undefined;
            }

            // Hiza gore renkli, gidis yonune akan rota (07.10.2026); onceden sira numarasina gore yesil -> kirmizi duz cizgiydi.
            _generalState.____tPolylines = rotaCiz(_generalState.____tMap, items);

            var bounds = new google.maps.LatLngBounds();

            items.map(x => new google.maps.LatLng(x.latitude, x.longitude)).forEach((item) => {
                bounds.extend(item);
            })

            _generalState.____tMap.fitBounds(bounds);

            return _generalState;
        })
    }

    return (
        <React.Fragment>
            <div style={{ height: '100%' }} className="d-flex flex-direction-row">
                <div style={{ position: 'relative' }} className="flex-grow-1">
                    <div style={{ width: '100%', height: '100%' }}>
                        {
                            isDebug && (
                                <div style={{ height: '10%' }}>
                                    <span className='d-block'>{generalState && generalState.____tDrawingPolygon ? 'ÇİZİM VAR' : 'ÇİZİM YOK'}</span>
                                    <span className='d-block'>{generalState && generalState.____tDrawingPolygonPoints.length == 0 ? 'BOŞ' : 'DOLU'}</span>

                                </div>
                            )
                        }

                        <div style={{ position: 'relative', height: isDebug ? '90%' : '100%' }}>
                            <GoogleMap
                                defaultCenter={defaultProps.center}
                                defaultZoom={defaultProps.zoom}
                                bootstrapURLKeys={{ key: GOOGLE_HARITA_ANAHTARI }}
                                yesIWantToUseGoogleMapApiInternals
                                onGoogleApiLoaded={({ map, maps }) => {
                                    handleApiLoaded(map, maps);
                                }}
                                options={{
                                    streetViewControl: false,
                                    clickableIcons: false,
                                    disableDefaultUI: true,
                                    disableDoubleClickZoom: true
                                }}

                            />

                            {
                                (!focusedDeviceId && !isAreaDetailShown) && (
                                    <div style={{ position: 'absolute', top: 0, left: 0, paddingLeft: 15, paddingTop: 15 }}>
                                        <form onSubmit={searchPlate}>
                                            <input value={searchedPlate} onChange={(e) => setSearchedPlate(e.target.value)} style={{ width: 250 }} placeholder="Plaka ara..." className="form-control form-control-solid" type="text" />
                                        </form>
                                    </div>
                                )
                            }

                            {
                                !focusedDeviceId && (
                                    <div style={{ position: 'absolute', bottom: 0, left: 0, paddingLeft: 15, paddingBottom: 15 }}>
                                        {
                                            !isAreaDetailShown && (
                                                <React.Fragment>
                                                    <button onClick={resetMap} className="btn btn-primary btn-sm" style={{ marginRight: 10 }}>Haritayı Sıfırla</button>
                                                    {/* <button onClick={startDrawing} className="btn btn-primary btn-sm">Bölge Ekle</button> */}
                                                    <button onClick={() => { setIsAreaDetailShown(true) }} className="btn btn-primary btn-sm">Bölgeler</button>
                                                </React.Fragment>
                                            )
                                        }

                                        {/* {
                                            isPolygonDrawing && (
                                                <React.Fragment>
                                                    <button onClick={openKmlOpenModal} className="btn btn-primary btn-sm" style={{ marginRight: 10 }}>KML Yükle</button>
                                                    <button onClick={stopDrawing} className="btn btn-primary btn-sm">Çizimi Bitir</button>
                                                </React.Fragment>
                                            )
                                        } */}
                                    </div>
                                )
                            }

                        </div>
                    </div>

                    <VehicleDetail
                        isShown={vehicleDetailHistory === undefined && data.find(x => x.deviceId == focusedDeviceId) !== undefined}
                        data={data.find(x => x.deviceId == focusedDeviceId)}
                        focusedDeviceId={focusedDeviceId}
                        resetFocusedDevice={resetFocusedDevice}
                        setVehicleDetailHistory={setVehicleDetailHistory}
                        lastEvents={lastEvents}
                        activeDetailTab={activeDetailTab}
                        setActiveDetailTab={setActiveDetailTab}
                        lastEventsTake={lastEventsTake}
                        setLastEventsTake={setLastEventsTake}
                        getLastEvents={getLastEvents}
                    />

                    <VehicleDetailHistory
                        isShown={vehicleDetailHistory !== undefined}
                        data={vehicleDetailHistory}
                        focusedDeviceId={focusedDeviceId}
                        setVehicleDetailHistory={setVehicleDetailHistory}
                        getDeviceHistory={getDeviceHistory}
                        getData={getData}
                        historyIndex={historyIndex}
                        historyData={historyData}
                        setHistoryIndex={setHistoryIndex}
                        setGeneralState={setGeneralState}
                        setHistoryData={setHistoryData}
                        setFocusedDeviceId={setFocusedDeviceId}
                        isDebug={isDebug}
                    />

                    <AreaDetail
                        isShown={isAreaDetailShown}
                        startDrawing={startDrawing}
                        isPolygonDrawing={isPolygonDrawing}
                        stopDrawing={stopDrawing}
                        areaList={areaList}
                        setIsShown={setIsAreaDetailShown}
                        hiddenAreas={hiddenAreas}
                        setHiddenAreas={setHiddenAreas}
                        getData={getData}
                        setCreateAreaModalVisible={setCreateAreaModalVisible}
                        setGeneralState={setGeneralState}
                        setToBeUpdatedArea={setToBeUpdatedArea}
                        generalState={generalState}
                        removeLastPolygonPoint={removeLastPolygonPoint}
                        setIsPolygonDrawing={setIsPolygonDrawing}
                        setPolygonPoint={setPolygonPoint}
                        setWithKml={setWithKml}
                    />
                </div>
            </div>

            <CreateAreaModal
                // points={generalState.____tDrawingPolygonPoints}
                toBeUpdatedArea={toBeUpdatedArea}
                // onSubmit={getData}
                // generalState={generalState}
                setGeneralState={setGeneralState}
                isShown={createAreaModalVisible}
                onClose={() => {
                    setCreateAreaModalVisible(false);
                    setWithKml(false);
                    setIsPolygonDrawing(false);
                    setToBeUpdatedArea(undefined);
                    getData(true, undefined);
                }}
                setWithKml={setWithKml}
                withKml={withKml}
            />
        </React.Fragment>
    );
}

export default Map;